import { MapPin, Clock, Star } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATI, URGENZE, IMPIANTI } from "@/lib/config";
import { ContattiRapidi } from "./ContattiRapidi";

export const Pill = ({ cls, children, testid }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider border ${cls}`} data-testid={testid}>{children}</span>
);

export const dataIt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const InterventoCard = ({ it, onOpen, onStato }) => (
  <article onClick={onOpen} className={`cursor-pointer rounded-2xl bg-white border p-5 space-y-4 shadow-sm hover:shadow-md transition-shadow ${it.urgenza === "emergenza" && ["nuovo", "in_corso"].includes(it.stato) ? "border-red-300 border-l-4 border-l-red-500" : "border-slate-200"}`} data-testid={`intervento-card-${it.id}`}>
    <div className="flex items-start justify-between gap-2">
      <div className="flex flex-wrap gap-1.5">
        <Pill cls={URGENZE[it.urgenza].cls} testid={`intervento-urgenza-${it.id}`}>{URGENZE[it.urgenza].label}</Pill>
        <Pill cls="bg-white text-slate-600 border-slate-200">{IMPIANTI[it.impianto]}</Pill>
        {it.recensito && <Pill cls="bg-amber-50 text-amber-700 border-amber-200" testid={`intervento-recensito-${it.id}`}>Recensito</Pill>}
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <Select value={it.stato} onValueChange={onStato}>
          <SelectTrigger className={`h-8 w-[130px] text-xs font-bold border ${STATI[it.stato].cls}`} data-testid={`intervento-stato-select-${it.id}`}><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(STATI).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`stato-option-${k}`}>{v.label}</SelectItem>)}</SelectContent>
        </Select>
      </div>
    </div>
    <div>
      <h3 className="text-lg font-bold tracking-tight">{it.tipo_problema}</h3>
      <p className="mt-1 text-sm text-slate-600 line-clamp-2">{it.descrizione}</p>
    </div>
    <div className="text-sm space-y-1">
      <p className="font-semibold">{it.nome} · <span className="font-mono text-slate-600">{it.telefono}</span></p>
      <p className="flex items-center gap-1.5 text-slate-500"><MapPin className="w-4 h-4 shrink-0" /> <span className="truncate">{it.indirizzo}</span></p>
      <p className="flex items-center gap-1.5 text-slate-500"><Clock className="w-4 h-4 shrink-0" /> {dataIt(it.created_at)} · preferisce {it.canale_preferito}</p>
    </div>
    <ContattiRapidi it={it} />
    {it.stato !== "annullato" && !it.recensito && (
      <button onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(`${window.location.origin}/recensione/${it.review_token}`).then(() => toast.success("Link recensione copiato")); }} className="w-full h-9 inline-flex items-center justify-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 text-amber-800 text-xs font-bold hover:bg-amber-100 transition-colors" data-testid={`intervento-copia-link-recensione-${it.id}`}>
        <Star className="w-4 h-4" /> Copia link recensione
      </button>
    )}
  </article>
);
